<template>
  <div class="phoneCodeYz">
    <el-dialog
      title="短信验证码验证"
      :visible.sync="visible"
      width="450px"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" clearable/>
        </el-form-item>
        <el-form-item label="验证码：" prop="code">
          <el-input v-model="form.code" placeholder="请输入验证码" clearable>
            <template slot="suffix">
              <el-button type="primary" @click="getCode" v-if="!countShow" size="mini">获取验证码</el-button>
              <el-button :disabled="true" type="info" v-show="countShow" size="mini">{{ count }}S</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 验证组件 -->
    <Verify ref="verify" :captcha-type="'blockPuzzle'" :img-size="{ width: '354px', height: '216px' }"/>
  </div>
</template>
<script>
import { validatePhone, validateTelephone } from "@/utils/validate";
import Verify from "@/components/verifition/Verify.vue"
import {sendCheckCode, useCheckCode} from "@/api/basic";
export default {
  name: "phoneCodeYz",
  components: {
    Verify
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    itemId: {
      type: Number,
      default: 0
    }
  },
  provide() {
    return {
      sendCheckCodeWithSlider: this.sendCheckCodeWithSlider
    };
  },
  data() {
    return {
      form:{
        phone: "",
        code: "",
      },
      rules: {
        phone: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {pattern:/^1(3|4|5|6|7|8|9)\d{9}$/, message: "请输入正确的手机号", trigger: "blur"}
        ],
        code: [
          {required: true, message: "请输入验证码", trigger: "blur"}
        ],
      },
      timer: null,
      countShow: false,
      count: 60
    };
  },
  methods: {
    // 获取验证码
    async getCode() {
      if (!this.form.phone) {
        this.$message.error("请先输入手机号");
        return;
      }
      const validPhone = validatePhone(this.form.phone) || validateTelephone(this.form.phone);
      if (!validPhone) {
        this.$message({
          title: "提示",
          message: "请输入正确的联系电话",
          type: "warning",
        });
      } else {
        this.$refs.verify.show();
      }
    },
    // 发送验证码带滑块
    async sendCheckCodeWithSlider(sliderParams) {
      this.countDown();
      const params = {
        phone: this.form.phone,
        businessCode: "globalTemplate",
        graphicData:sliderParams,
      }
      try{
        await sendCheckCode(params)
        this.$message.success({
          title: '提示',
          message: '短信发送成功，请注意查收',
          type: 'success',
        });
        return true
      }catch (e){
        return false
      }
    },
    // 倒计时
    countDown() {
      this.countShow = true;
      this.timer = setInterval(() => {
        this.count--;
        if (this.count === 0) {
          clearInterval(this.timer);
          this.countShow = false;
          this.count = 60;
        }
      }, 1000);
    },
    // 验证码验证
    async submit() {
      this.$refs["form"].validate(async(valid) => {
        if (valid) {
          const params = {
            phone: this.form.phone,
            checkCode: this.form.code,
            businessCode: 'globalTemplate',
          };
          const res = await useCheckCode(params)
          if (res.data.resultCode == '200') {
            this.$message.success("验证成功");
            sessionStorage.setItem("phone", this.form.phone);
            setTimeout(() => {
              this.$emit("success",this.itemId);
            }, 1000);
          } else {
            this.$message.error(res.data.repMsg);
          }
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
  destroyed() {
    clearInterval(this.timer);
  }
}
</script>
<style scoped>
.phoneCodeYz .el-dialog{
  width: 400px;
}
.phoneCodeYz .el-dialog .el-button--primary{
  background: rgb(26, 127, 221);
  border-color: rgb(26, 127, 221);
}
</style>
